/** Query-параметр адреса карточки диалога с правленым элементом заключения */
export const EVALUATION_TARGET_PARAM = 'evaluationTarget';

/** Ключ правленого элемента заключения: балл блока или комментарий правила */
export const buildEvaluationTargetKey = (target: 'block' | 'rule', targetId: number): string => `${target}-${targetId}`;
